export default {
    created() {
      this.$options.errorCaptured = () => true;
    }
};